import styled from 'styled-components';

export const Content = styled.div`
  padding: 0 5px;
  background-color: #2c353d;
  border-radius: 4px;
  height: 4px;
`;

export const Thumb = styled.div`
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background-color: #e6eaec;
  box-shadow: 0 1px 3px rgba(16, 24, 32, 0.5);
`;

export const Track = styled.div`
  height: 4px;
  border-radius: 4px;
  background-color: #2c353d;
`;
